'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var ipfsBitswap = require('ipfs-bitswap');

var libp2p = require('./libp2p.js');

var multiaddr = require('multiaddr');

var errCode = require('err-code');

var blockStorage = require('../block-storage.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var Network = /*#__PURE__*/function () {
  function Network(peerId, libp2p, bitswap, repo, blockstore) {
    _classCallCheck(this, Network);

    this.peerId = peerId;
    this.libp2p = libp2p;
    this.bitswap = bitswap;
    this.repo = repo;
    this.blockstore = blockstore;
  }

  _createClass(Network, null, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var peerId, repo, print, hashers, options, config, libp2p$1, _iterator, _step, ma, bitswap, blockstore;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                peerId = _ref.peerId, repo = _ref.repo, print = _ref.print, hashers = _ref.hashers, options = _ref.options;

                if (!repo.closed) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return repo.open();

              case 4:
                _context.next = 6;
                return repo.config.getAll();

              case 6:
                config = _context.sent;
                _context.next = 9;
                return libp2p.createLibp2p({
                  options: options,
                  repo: repo,
                  peerId: peerId,
                  multiaddrs: readAddrs(peerId, config),
                  config: config,
                  keychainConfig: undefined
                });

              case 9:
                libp2p$1 = _context.sent;

                if (!libp2p$1.keychain) {
                  _context.next = 13;
                  break;
                }

                _context.next = 13;
                return libp2p$1.loadKeychain();

              case 13:
                _context.next = 15;
                return libp2p$1.start();

              case 15:
                _iterator = _createForOfIteratorHelper(libp2p$1.multiaddrs);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    ma = _step.value;
                    print("Swarm listening on ".concat(ma, "/p2p/").concat(peerId.toB58String()));
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                bitswap = ipfsBitswap.createBitswap(libp2p$1, repo.blocks, {
                  statsEnabled: true,
                  hashLoader: hashers
                });
                _context.next = 20;
                return bitswap.start();

              case 20:
                blockstore = new blockStorage.BlockStorage(repo.blocks, bitswap);
                repo.blocks = blockstore;
                repo.pins.blockstore = blockstore;
                return _context.abrupt("return", new Network(peerId, libp2p$1, bitswap, repo, blockstore));

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function start(_x) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(network) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                network.repo.blocks = network.blockstore.unwrap();
                network.repo.pins.blockstore = network.blockstore.unwrap();
                _context2.next = 4;
                return Promise.all([network.bitswap.stop(), network.libp2p.stop()]);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function stop(_x2) {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }]);

  return Network;
}();

var readAddrs = function readAddrs(peerId, config) {
  var peerIdStr = peerId.toB58String();
  var addrs = [];
  var swarm = config.Addresses && config.Addresses.Swarm || [];

  var _iterator2 = _createForOfIteratorHelper(swarm),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var addr = _step2.value;
      var ma = new multiaddr.Multiaddr(addr);

      if (ma.protoCodes().includes(WEBSOCKET_STAR_PROTO_CODE)) {
        throw errCode__default["default"](new Error('websocket-star swarm addresses are not supported. See https://github.com/ipfs/js-ipfs/issues/2779'), 'ERR_WEBSOCKET_STAR_SWARM_ADDR_NOT_SUPPORTED');
      }

      var maId = ma.getPeerId();

      if (maId && maId !== peerIdStr) {
        ma = ma.encapsulate("/p2p/".concat(peerIdStr));
      }

      addrs.push(ma);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return addrs;
};

var WEBSOCKET_STAR_PROTO_CODE = 479;
exports.Network = Network;